import {} from "@knyt/artisan";
import { EventListenerManager } from "./EventListenerManager.js";
/**
 * Creates a manager of event listeners on a target element for a host.
 *
 * @beta
 */
export function listenTo(host, target) {
    return new EventListenerManager(host, target);
}
